import { useState, useEffect, useRef } from 'react';
import './InfoIcon.css';

export default function InfoIcon({ source, sources }) {
  const [open, setOpen] = useState(false);
  const popoverRef = useRef(null);
  const buttonRef = useRef(null);

  const allSources = sources
    ? sources
    : source
      ? [source]
      : [];

  const hasVerification = allSources.some(s => s.verificationNeeded);

  useEffect(() => {
    if (!open) return;

    function onKeyDown(e) {
      if (e.key === 'Escape') setOpen(false);
    }

    function onPointerDown(e) {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(e.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    }

    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('pointerdown', onPointerDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('pointerdown', onPointerDown);
    };
  }, [open]);

  if (allSources.length === 0) return null;

  return (
    <span className="info-icon-wrapper">
      <button
        ref={buttonRef}
        type="button"
        className={`info-icon-btn${hasVerification ? ' info-icon-btn--caution' : ''}`}
        aria-label="View source"
        aria-expanded={open}
        aria-haspopup="dialog"
        onClick={() => setOpen(prev => !prev)}
      >
        <span aria-hidden="true">i</span>
      </button>

      {open && (
        <div
          ref={popoverRef}
          role="dialog"
          aria-label="Source information"
          className={`info-icon-popover${hasVerification ? ' info-icon-popover--caution' : ''}`}
        >
          {hasVerification && (
            <p className="info-icon-caution-msg">
              Needs verification — confirm at orientation or on the school website.
            </p>
          )}

          <ul className="info-icon-source-list">
            {allSources.map((src, i) => (
              <li key={i} className="info-icon-source">
                <a
                  href={src.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="info-icon-source-link"
                >
                  {src.label} ↗
                </a>
                {src.note && (
                  <p className="info-icon-source-note">{src.note}</p>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </span>
  );
}
